import { ValidationResult } from '../../../@types/validation-types'

export const areAllFieldsValid = (v: ValidationResult): boolean => {
  let length = 0
  Object.entries(v).forEach(([_screen, properties]) => {
    if (properties.fields) {
      Object.entries(properties.fields).forEach(
        ([_prop, validationResult]) => (length += validationResult?.length ?? 0)
      )
    }
  })
  return length === 0
}
